module.exports = __webpack_public_path__ + "static/pattern2-6c93c20860d0e726894e1a0660599d7f.svg";